import i18n from '../../language/index'
import link from '@/base/linkData'
//在这里配置轮播横幅的基础数据
const list = [
  'https://staticjs.71360.com/3/static/txys-001/image/banner_1.jpg',
  // 'https://staticjs.71360.com/3/static/txys-001/image/banner_2.jpg',
  // 'https://staticjs.71360.com/3/static/txys-001/image/banner_3.jpg',
]

const arr = [];
list.map((item)=>{
  arr.push({
    src:item,
    link:JSON.parse(JSON.stringify(link))
  })
});

export default arr



// WEBPACK FOOTER //
// ./src/widgets/full_screen_banner/banner_data.js